var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiTaskSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-label": "Pixel task + sparkle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pixel task + sparkle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h9v1H3v15h12V11h1v10h-1v1H3v-1H2V6h1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11h1v1h1v1h1v-1h1v-1h1v-1h1v2h-1v1H9v1H8v1H7v-1H6v-1H5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17h7v1H5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 1h1v2h1v1h2v1h-2v1h-1v2h-1V6h-1V5h-2V4h2V3h1Z M18 3v1h-1v1h1v1h1V5h1V4h-1V3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTaskSpark);
export default __webpack_public_path__ + "static/media/ai-task-spark.4a4dc4c70922735ff4768438eb1845d7.svg";
export { ForwardRef as ReactComponent };